/**
 * This function is needed temporarily for transition
 * from old to new products library.
 *
 * The function checks if it is a PL_BRAND or not,
 * PL_BRANDS are created specifically for new Product Library functionality.
 *
 * The value returned from this function can be overridden with a truthy value
 *
 *
 * @returns boolean
 */

export const isPLUpgradeBrand = (): boolean => {
  // setting to true for all brands so we can remove flagsmith
  return true;
};
